var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-n15"},[_c('v-divider'),_c('v-toolbar',{directives:[{name:"appcolor",rawName:"v-appcolor"}],attrs:{"elevation":"0"}},[_c('body',[_vm._t("cbody",function(){return [_vm._v("Defaut content")]})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }